const EXTENSION_MIME_MAP: Record<string, string> = {
  csv: 'text/csv',
  json: 'application/json',
  md: 'text/markdown',
  pdf: 'application/pdf',
  txt: 'text/plain',
  html: 'text/html',
};

export function getMimeTypeFromPath(path: string): string {
  const extension = path.split('.').pop()?.toLowerCase() ?? '';
  return EXTENSION_MIME_MAP[extension] ?? 'text/plain';
}
